import React, { useState, useEffect, FC } from 'react';
import KickImage from 'Reuseables/KickImage';
import Slider from 'react-slick';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import SliderLeftHovered from '../../../../images/left-black-arrow-3.png';
import SliderRightHovered from '../../../../images/right-black-arrow-3.png';
import ArrowHPPrev from '../../../../images/arrow-hp-prev.png';
import ArrowHPNext from '../../../../images/arrow-hp-next.png';
import ArrowBlackRight from '../../../../images/arrow-black-right.png';
import ArrowBlackLeft from '../../../../images/arrow-black-left.png';
import emptySneakerImg from '../../../../images/emptysneakers2.png';
import emptyApparelImg from '../../../../images/emptyapparels.png';
import emptyHandbagImg from '../../../../images/emptyhandbags.png';
import HotProduct from '../../../../images/fire-product.png';
import { TextRupiah } from '../../../Text';
import { convertBrandNameToSlug, getCloudImageUrl, emptyImage } from '../../../../utils/Helpers';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

interface PreviousSlide {
  className: string;
  style: Object;
  onClick: () => any;
}

const PrevSlide = (props: PreviousSlide) => {
  const { className, style, onClick } = props;
  const [hovered, setHoveredLeft] = useState(false);

  function handleHover() {
    setHoveredLeft(!hovered);
  }

  const LeftArrow = styled.div`
    &::before {
      content: '';
    }
    img {
      width: 40px !important;
      height: 40px !important;
      left: 10px !important;
      position: absolute;
      object-fit: contain;
    }
    @media (max-width: 480px) {
      img {
        width: 30px !important;
        height: 30px !important;
        position: absolute;
        left: -5px;
      }
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{
        ...style,
        left: '40px !important',
        width: '40px',
        height: '40px',
        display: window.screen.availWidth < 640 ? 'none' : 'block',
      }}
      onClick={onClick}
      onMouseEnter={handleHover}
      onMouseLeave={handleHover}
    >
      <KickImage src={hovered ? ArrowBlackLeft : SliderLeftHovered} alt="..." />
    </LeftArrow>
  );
};

const PrevSlideHP = (props: PreviousSlide) => {
  const { className, style, onClick } = props;
  const [hovered, setHoveredLeft] = useState(false);

  function handleHover() {
    setHoveredLeft(!hovered);
  }

  const LeftArrow = styled.div`
    &::before {
      content: '';
    }
    img {
      width: 40px !important;
      height: 40px !important;
      left: 20px !important;
      position: absolute;
      object-fit: contain;
    }
    @media (max-width: 480px) {
      img {
        width: 30px !important;
        height: 30px !important;
        position: absolute;
        left: -5px;
      }
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{
        ...style,
        left: '40px !important',
        width: '40px',
        height: '40px',
        display: window.screen.availWidth < 640 ? 'none' : 'block',
      }}
      onClick={onClick}
      onMouseEnter={handleHover}
      onMouseLeave={handleHover}
    >
      <KickImage src={hovered ? ArrowBlackLeft : ArrowHPPrev} alt="..." />
    </LeftArrow>
  );
};

interface NextSlide {
  className: string;
  style: Object;
  onClick: () => any;
}

const NextSlide = (props: NextSlide) => {
  const { className, style, onClick } = props;
  const [hovered, setHoveredLeft] = useState(false);

  function handleHover() {
    setHoveredLeft(!hovered);
  }

  const LeftArrow = styled.div`
    &::before {
      content: '';
    }
    img {
      width: 40px !important;
      height: 40px !important;
      object-fit: contain;
      right: -90px;
      position: absolute;
    }
    @media (max-width: 480px) {
      img {
        right: 5px;
        width: 30px !important;
        height: 30px !important;
      }
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{
        ...style,
        display: window.screen.availWidth < 640 && 'none',
        width: '40px',
        height: '40px',
      }}
      onClick={onClick}
      onMouseEnter={handleHover}
      onMouseLeave={handleHover}
    >
      <KickImage src={hovered ? ArrowBlackRight : SliderRightHovered} alt="..." />
    </LeftArrow>
  );
};

const NextSlideHP = (props: NextSlide) => {
  const { className, style, onClick } = props;
  const [hovered, setHoveredLeft] = useState(false);

  function handleHover() {
    setHoveredLeft(!hovered);
  }

  const LeftArrow = styled.div`
    &::before {
      content: '';
    }
    img {
      width: 40px !important;
      height: 40px !important;
      object-fit: contain;
      right: -80px;
      position: absolute;
    }
    @media (max-width: 480px) {
      img {
        right: 5px;
        width: 30px !important;
        height: 30px !important;
      }
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{
        ...style,
        display: window.screen.availWidth < 640 && 'none',
        width: '40px',
        height: '40px',
      }}
      onClick={onClick}
      onMouseEnter={handleHover}
      onMouseLeave={handleHover}
    >
      <KickImage src={hovered ? ArrowBlackRight : ArrowHPNext} alt="..." />
    </LeftArrow>
  );
};

type ProductSlider = {
  dataProducts: Array<DataProducts>;
  title: string;
  dataCategory: string;
  isHotProducts: boolean;
  isRecommendedProduct: boolean;
  chosenOption: string;
  activeBrowseAll: boolean;
  navigateUrl: string;
  history: any;
  isRaffle: boolean;
  hasShadow: boolean;
  collectionId: number | null;
};

interface ProductCategory {
  category: any;
}

interface ProductVariantImages {
  URL: string;
}
interface DataProducts {
  id: number;
  slug: string;
  product: ProductCategory;
  price: number;
  editors_choice: boolean;
  product_variant_images: Array<ProductVariantImages>;
  display_name: string;
}

interface Category {
  category: CategoryDetail;
}

interface CategoryDetail {
  name: string;
}
interface URL {
  URL: string;
}
interface ItemMobile {
  product: Category;
  price: number;
  editors_choice: boolean;
  id: number;
  slug: string;
  product_variant_images: Array<URL>;
  display_name: string;
  isRecommendedProduct: boolean;
  retail_price: number;
  latest_price: LatestPrice;
  category: string;
}
interface LatestPrice {
  asking_price: number;
}

const ProductSlider: FC<ProductSlider> = ({
  dataProducts,
  title,
  dataCategory,
  isHotProducts,
  isRecommendedProduct,
  chosenOption,
  activeBrowseAll,
  navigateUrl,
  isRaffle,
  hasShadow,
  history,
  query,
  isCollectionHero,
  isPreVerified,
  slug,
  collectionId,
  userCurrency
}) => {
  const [settings, setSettings] = useState({});

  useEffect(() => {
    if (dataProducts && dataProducts.length >= 4) {
      // Set slider setting if products is more than 4
      setSettings({
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        prevArrow: <PrevSlide />,
        nextArrow: <NextSlide />,
        responsive: [
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
  }, [dataProducts]);

  if (window.screen.availWidth < 480 && isHotProducts) {
    // Display slider if isHotProducts props is available and viewed on mobile screen
    return (
      <div className="Hot-Products__slider">
        {dataProducts &&
          dataProducts.length > 0 &&
          dataProducts.map((item: ItemMobile) => {
            let categoryUrl = '';

            let price = 0;

            if (item.latest_price && item.latest_price.asking_price) {
              price = item.latest_price.asking_price;
            }

            if (
              item.product &&
              item.product.category &&
              item.product.category.name
            ) {
              categoryUrl =
                item.product.category.name === 'apparels' ||
                item.product.category.name === 'Apparels'
                  ? 'apparel'
                  : item.product.category.name === 'Sneakers'
                  ? 'sneakers'
                  : item.product.category.name === 'handbags'
                  ? 'luxury'
                  : item.product.category.name;
            } else if (item.product && item.product.category) {
              categoryUrl =
                item.product.category === 'apparels' ||
                item.product.category === 'Apparels'
                  ? 'apparel'
                  : item.product.category === 'sneakers' ||
                    !item.product.category
                  ? 'Sneakers'
                  : item.product.category === 'handbags'
                  ? 'luxury'
                  : item.product.category;
            } else {
              categoryUrl =
                item.category === 'apparels' || item.category === 'Apparels'
                  ? 'apparel'
                  : item.category === 'sneakers' || !item.category
                  ? 'sneakers'
                  : item.category === 'handbags' || item.category === 'Handbags'
                  ? 'luxury'
                  : item.category;
            }

            let pathname = `/${categoryUrl}/${item.id}/${item.slug}`;

            let search = ``;
            if (slug && !isCollectionHero && !item.vintage)
              search += `?collection=${slug}`;
            if (!slug && isCollectionHero && !item.vintage)
              search += '?express_shipping=true';
            if (!slug && !isCollectionHero && item.vintage)
              search += '?vintage=true';

            if (slug && isCollectionHero && !item.vintage)
              search += `?collection=${slug}&express_shipping=true`;
            if (!slug && isCollectionHero && item.vintage)
              search += `?express_shipping=true&vintage=true`;
            if (slug && !isCollectionHero && item.vintage)
              search += `?collection=${slug}&vintage=true`;

            if (slug && isCollectionHero && item.vintage)
              search += `?collection=${slug}&express_shipping=true&vintage=true`;

            if (collectionId) {
              search += `&collection_id=${collectionId}`;
            }

            const brand = item && item.product && item.product.brand;
            const categoryName =
              item &&
              item.product &&
              item.product.category &&
              item.product.category.name;

            const isOnlyKickPoint = item?.variant_payment_methods?.length === 1 && !!item?.variant_payment_methods?.find((item) => item?.payment_method === "kick_point" || item === "kick_point");

            return (
              <Link
                to={{
                  pathname,
                  search,
                }}
                key={item.id}
                className="categories-section"
              >
                <div
                  style={{
                    position: item.editors_choice ? 'relative' : 'static',
                  }}
                >
                  {item.editors_choice && (
                    <KickImage
                      src={HotProduct}
                      alt="Hot product"
                      className="isHotProducts"
                    />
                  )}
                  <KickImage
                    src={
                      item.product_variant_images.length > 0 &&
                      item.product_variant_images[0].URL.indexOf(
                        's3.amazonaws.com',
                      ) > 0
                        ? getCloudImageUrl(
                            item.product_variant_images[0].URL,
                            500,
                          )
                        : emptyImage(
                            item &&
                              item.product &&
                              item.product.category &&
                              item.product.category.name
                              ? item.product.category.name
                              : item.product.category,
                          )
                    }
                    alt=""
                    className="homepage-product__image"
                  />
                  {categoryName === 'handbags' ||
                  item.category === 'handbags' ? (
                    <p className="homepage-product-mobile__brandName">
                      {brand?.flat?.length > 0 ? brand?.flat[0] : brand?.name}
                    </p>
                  ) : null}
                  <p className="homepage-product-mobile__displayName">
                    {item.display_name}
                  </p>
                  <p
                    style={{ color: '#159953' }}
                    className="homepage-product__price"
                  >
                    {price ? (
                      <TextRupiah
                        currency="IDR. "
                        color="#159953"
                        align="right"
                        value={price.toString()}
                        isOnlyKickPoint={isOnlyKickPoint}
                      />
                    ) : (
                      <span style={{ color: 'red' }}>Out of stock</span>
                    )}
                  </p>
                </div>
              </Link>
            );
          })}
        {chosenOption && !isRaffle && dataProducts.length > 0 && (
          // View all collection
          <Link target="_blank" to={navigateUrl} className="homepage-lastSlide">
            <div
              style={{
                border: isHotProducts ? '1px solid #fff' : '1px solid #e0e0e0',
                width: '240px',
                marginRight: '40px',
              }}
              className="homepage-showAll"
              onClick={() => {
                localStorage.removeItem('collectionSortedBy');
              }}
            >
              <h4
                style={{
                  color: isHotProducts ? '#fff' : '#242424',
                  paddingLeft: '0px',
                }}
              >
                View All
              </h4>
              <p style={{ color: isHotProducts ? '#fff' : '#242424' }}>
                {chosenOption}
              </p>
            </div>
          </Link>
        )}
      </div>
    );
  }

  if (window.screen.availWidth < 480 && !isHotProducts) {
    // Display products if isHotProducts props is not available and viewed on mobile screen
    return (
      <div className="product-slider-mobile__container">
        {dataProducts &&
          dataProducts.map((item: ItemMobile) => {
            let categoryUrl = '';
            let imageUrl = '';
            let price = 0;

            if (
              item.product &&
              item.product.category &&
              item.product.category.name
            ) {
              categoryUrl =
                item.product.category.name === 'apparels' ||
                item.product.category.name === 'Apparels'
                  ? 'apparel'
                  : item.product.category.name === 'sneakers' ||
                    !item.product.category.name
                  ? 'sneakers'
                  : item.product.category.name === 'handbags'
                  ? 'luxury'
                  : item.product.category.name;
            } else if (item.product && item.product.category) {
              categoryUrl =
                item.product.category === 'apparels' ||
                item.product.category === 'Apparels'
                  ? 'apparel'
                  : item.product.category === 'sneakers' ||
                    !item.product.category
                  ? 'Sneakers'
                  : item.product.category === 'handbags'
                  ? 'luxury'
                  : item.product.category;
            } else {
              categoryUrl =
                item.category === 'apparels' || item.category === 'Apparels'
                  ? 'apparel'
                  : item.category === 'sneakers' || !item.category
                  ? 'sneakers'
                  : item.category === 'handbags' || item.category === 'Handbags'
                  ? 'luxury'
                  : item.category;
            }

            if (isRecommendedProduct) {
              imageUrl = item.image_url;
              price = item.latest_price;
            } else if (isRaffle) {
              imageUrl = item.image;
              price = item.price;
            } else {
              imageUrl =
                item.product_variant_images &&
                item.product_variant_images.length > 0 &&
                item.product_variant_images[0].URL;
              price = item.price;
            }

            let pathname = isRaffle
              ? `${categoryUrl}/raffle/${query}`
              : `${categoryUrl}/${item.id}/${item.slug}`;

            let search = ``;
            if (slug && !isCollectionHero && !item.vintage)
              search += `?collection=${slug}`;
            if (!slug && isCollectionHero && !item.vintage)
              search += '?express_shipping=true';
            if (!slug && !isCollectionHero && item.vintage)
              search += '?vintage=true';

            if (slug && isCollectionHero && !item.vintage)
              search += `?collection=${slug}&express_shipping=true`;
            if (!slug && isCollectionHero && item.vintage)
              search += `?express_shipping=true&vintage=true`;
            if (slug && !isCollectionHero && item.vintage)
              search += `?collection=${slug}&vintage=true`;

            if (slug && isCollectionHero && item.vintage)
              search += `?collection=${slug}&express_shipping=true&vintage=true`;

            if (collectionId) {
              search += `&collection_id=${collectionId}`;
            }
            const brand = item && item.product && item.product.brand;
            const categoryName =
              item &&
              item.product &&
              item.product.category &&
              item.product.category.name;

            const isOnlyKickPoint = item?.variant_payment_methods?.length === 1 && !!item?.variant_payment_methods?.find((item) => item?.payment_method === "kick_point" || item === "kick_point");

            return (
              <Link
                key={item.id}
                className="homepage-product__mobile"
                to={{ pathname, search }}
              >
                <div
                  style={{
                    position: item.editors_choice ? 'relative' : 'static',
                  }}
                  className="homepage-product-container__mobile"
                >
                  {item.editors_choice && (
                    <KickImage
                      src={HotProduct}
                      alt="Hot product"
                      className="isHotProducts"
                    />
                  )}
                  <KickImage
                    src={
                      imageUrl && imageUrl.indexOf('s3.amazonaws.com') > 0
                        ? getCloudImageUrl(imageUrl, 500)
                        : emptyImage(dataCategory)
                    }
                    alt=""
                    className="homepage-product__image"
                  />
                  {categoryName === 'handbags' ? (
                    <p className="homepage-product-mobile__brandName">
                      {brand?.flat?.length > 0 ? brand?.flat[0] : brand?.name}
                    </p>
                  ) : null}
                  <p className="homepage-product-mobile__displayName">
                    {item.display_name}
                  </p>
                  <p
                    style={{ color: '#159953' }}
                    className="homepage-product__price"
                  >
                    {price ? (
                      <TextRupiah
                        currency="IDR. "
                        color="#159953"
                        align="right"
                        value={price && price.toString()}
                        isOnlyKickPoint={isOnlyKickPoint}
                      />
                    ) : (
                      <span style={{ color: 'red' }}>Out of Stock</span>
                    )}
                  </p>
                </div>
              </Link>
            );
          })}
        {chosenOption && !isRaffle && dataProducts && dataProducts.length > 0 && (
          // View all collection option
          <Link
            target="_blank"
            to={navigateUrl}
            className="homepage-lastSlide"
            onClick={() => localStorage.removeItem('collectionSortedBy')}
          >
            <div
              style={{
                border: isHotProducts ? '1px solid #fff' : '1px solid #e0e0e0',
                width: '240px',
                marginRight: '40px',
                height: '240px',
              }}
              className="homepage-showAll"
            >
              <h4
                style={{
                  color: isHotProducts ? '#fff' : '#242424',
                  paddingLeft: '0px',
                }}
              >
                View All
              </h4>
              <p style={{ color: isHotProducts ? '#fff' : '#242424' }}>
                {chosenOption}
              </p>
            </div>
          </Link>
        )}
      </div>
    );
  }

  interface ProductData {
    id: number;
    product: Category;
    price: number;
    product_variant_images: Array<URL>;
    display_name: string;
    editors_choice: boolean;
    category: string;
    image_url: string;
    latest_price: string;
    slug: string;
  }

  interface URL {
    URL: string;
  }

  interface Category {
    category: Name;
  }

  interface Name {
    name: string;
  }

  const onClickItem = (url) => {
    if (isRaffle) history.push(`${category}/raffle/${query}`);
    else history.push(url);
  };

  if (dataProducts && dataProducts.length > 0 && dataProducts.length < 4) {
    // Display products if products is available but have less than 4 products on desktop screen
    return (
      <div id="homepage-lessThan4__container">
        {dataProducts.map((item) => {
          let categoryUrl =
            item.category === 'apparels' || item.category === 'Apparels'
              ? 'apparel'
              : item.category === 'sneakers' || !item.category
              ? 'sneakers'
              : item.category === 'handbags'
              ? 'luxury'
              : item.category;

          let imageUrl = '';
          let price;
          const brand = item && item.product && item.product.brand;
          const brandSlug = brand?.flat?.[0] ? convertBrandNameToSlug(brand?.flat?.[0]) : brand?.slug;

          if (isRecommendedProduct) {
            imageUrl = item.image_url;
            price = item.latest_price;
          } else if (isRaffle) {
            imageUrl = item.image;
            price = item.price;
          } else {
            imageUrl =
              item.product_variant_images &&
              item.product_variant_images.length > 0 &&
              item.product_variant_images[0].URL;
            price = item.price;
          }

          let pathname = isRaffle
            ? `${category}/raffle/${query}`
            : `${categoryUrl}/${brandSlug}/${item.slug}`;

          let search = ``;
          if (slug && !isCollectionHero && !item.vintage)
            search += `?collection=${slug}`;
          if (!slug && isCollectionHero && !item.vintage)
            search += '?express_shipping=true';
          if (!slug && !isCollectionHero && item.vintage)
            search += '?vintage=true';

          if (slug && isCollectionHero && !item.vintage)
            search += `?collection=${slug}&express_shipping=true`;
          if (!slug && isCollectionHero && item.vintage)
            search += `?express_shipping=true&vintage=true`;
          if (slug && !isCollectionHero && item.vintage)
            search += `?collection=${slug}&vintage=true`;

          if (slug && isCollectionHero && item.vintage)
            search += `?collection=${slug}&express_shipping=true&vintage=true`;

          if (collectionId) {
            search += `&collection_id=${collectionId}`;
          }

          if(search.includes('?')){
            search += '&from=home';
          }
          else{
            search += '?from=home'
          }

          const categoryName =
            item &&
            item.product &&
            item.product.category &&
            item.product.category.name;
          const isOnlyKickPoint = item?.variant_payment_methods?.length === 1 && !!item?.variant_payment_methods?.find((item) => item?.payment_method === "kick_point" || item === "kick_point");

          return (
            <Link
              to={{ pathname, isCollectionHero, search }}
              key={item.id}
              className="homepage-product__section"
            >
              <div
                style={{ position: item.editors_choice && 'relative' }}
                className="homepage-product__container"
              >
                {item.editors_choice && (
                  <KickImage
                    className="isHotProduct"
                    src={HotProduct}
                    alt="hot product"
                  />
                )}
                <KickImage
                  className="homepage-product__img"
                  src={
                    imageUrl && imageUrl.indexOf('s3.amazonaws.com') > 0
                      ? getCloudImageUrl(imageUrl, 500)
                      : emptyImage(item.category)
                  }
                  alt=""
                  style={{ width: 'auto' }}
                />
                {categoryName === 'handbags' ? (
                  <p className="homepage-product__brand">
                    {brand?.flat?.length > 0 ? brand?.flat[0] : brand?.name}
                  </p>
                ) : null}
                <p className="homepage-product__name">{item.display_name}</p>
                <p
                  style={{ color: '#159953' }}
                  className="homepage-product__price"
                >
                  {price ? (
                    <TextRupiah
                      currency="IDR. "
                      color="#159953"
                      align="right"
                      value={price && price.toString()}
                      isOnlyKickPoint={isOnlyKickPoint}
                    />
                  ) : (
                    <span style={{ color: 'red' }}>Out of Stock</span>
                  )}
                </p>
              </div>
              {/* {chosenOption && dataProducts.length > 0 && (
                // View all collection
                <Link
                  target="_blank"
                  to={navigateUrl}
                  className="homepage-lastSlide"
                >
                  <div
                    style={{
                      border: isHotProducts
                        ? '1px solid #fff'
                        : '1px solid #e0e0e0',
                      width: '285px',
                    }}
                    className="homepage-showAll"
                  >
                    <h4 style={{ color: isHotProducts ? '#fff' : '#242424' }}>
                      View All
                    </h4>
                    <p style={{ color: isHotProducts ? '#fff' : '#242424' }}>
                      {chosenOption}
                    </p>
                  </div>
                </a>
              )} */}
            </Link>
          );
        })}
        {chosenOption && dataProducts.length > 0 && (
          // View all collection
          <a target="_blank" href={navigateUrl} className="homepage-lastSlide">
            <div
              style={{
                border: isHotProducts ? '1px solid #fff' : '1px solid #e0e0e0',
                width: '285px',
              }}
              className="homepage-showAll"
            >
              <h4 style={{ color: isHotProducts ? '#fff' : '#242424' }}>
                View All
              </h4>
              <p style={{ color: isHotProducts ? '#fff' : '#242424' }}>
                {chosenOption}
              </p>
            </div>
          </a>
        )}
      </div>
    );
  }

  return (
    // Other slider collection on desktop
    <Slider {...settings}>
      {dataProducts &&
        dataProducts.length > 0 &&
        dataProducts.map((item: ProductData, index) => {
          let categoryUrl = '';
          if (
            item.product &&
            item.product.category &&
            item.product.category.name
          ) {
            // Set categoryUrl if item.product.category.name object key is available
            categoryUrl =
              item.product.category.name === 'apparels' ||
              item.product.category.name === 'Apparels'
                ? 'apparel'
                : item.product.category.name === 'sneakers' ||
                  !item.product.category.name
                ? 'sneakers'
                : item.product.category.name === 'handbags'
                ? 'luxury'
                : item.product.category.name;
          } else if (item.product && item.product.category) {
            // Set categoryUrl if item.product.category object key is available
            categoryUrl =
              item.product.category == 'apparels' ||
              item.product.category == 'Apparels'
                ? 'apparel'
                : item.product.category == 'sneakers' || !item.product.category
                ? 'Sneakers'
                : item.product.category == 'handbags'
                ? 'luxury'
                : item.product.category;
          } else {
            // Set categoryUrl if item.product.category and item.product.category.name object key is not available
            categoryUrl =
              item.category === 'apparels' || item.category === 'Apparels'
                ? 'apparel'
                : item.category === 'sneakers' || !item.category
                ? 'sneakers'
                : item.category === 'handbags' || item.category === 'Handbags'
                ? 'luxury'
                : item.category;
          }
          if (
            isHotProducts &&
            item.id &&
            item.slug &&
            item.display_name &&
            item.price &&
            item.product_variant_images.length > 0
          ) {
            const brand = item && item.product && item.product.brand;
            const brandSlug = brand?.flat?.[0] ? convertBrandNameToSlug(brand?.flat?.[0]) : brand?.slug;

            let pathname = isRaffle
              ? `${category}/raffle/${query}`
              : `${categoryUrl}/${brandSlug}/${item.slug}`;

            let search = ``;
            if (slug && !isCollectionHero && !item.vintage)
              search += `?collection=${slug}`;
            if (!slug && isCollectionHero && !item.vintage)
              search += '?express_shipping=true';
            if (!slug && !isCollectionHero && item.vintage)
              search += '?vintage=true';

            if (slug && isCollectionHero && !item.vintage)
              search += `?collection=${slug}&express_shipping=true`;
            if (!slug && isCollectionHero && item.vintage)
              search += `?express_shipping=true&vintage=true`;
            if (slug && !isCollectionHero && item.vintage)
              search += `?collection=${slug}&vintage=true`;

            if (slug && isCollectionHero && item.vintage)
              search += `?collection=${slug}&express_shipping=true&vintage=true`;

            if (collectionId) {
              search += `&collection_id=${collectionId}`;
            }

            if(search.includes('?')){
              search += '&from=home';
            }
            else{
              search += '?from=home'
            }

            const categoryName =
              item &&
              item.product &&
              item.product.category &&
              item.product.category.name;

            const isOnlyKickPoint = item?.variant_payment_methods?.length === 1 && !!item?.variant_payment_methods?.find((item) => item?.payment_method === "kick_point" || item === "kick_point");

            return (
              // For desktop slider that has isHotProducts props
              <Link
                to={{ pathname, search }}
                key={item.id}
                className="homepage-product__section"
              >
                <div
                  style={{ position: item.editors_choice && 'relative' }}
                  className="homepage-product__container"
                >
                  {item.editors_choice && (
                    <KickImage
                      className="isHotProduct"
                      src={HotProduct}
                      alt="hot product"
                    />
                  )}
                  <KickImage
                    className="homepage-product__img"
                    src={
                      item.product_variant_images.length > 0 &&
                      item.product_variant_images[0].URL.indexOf(
                        's3.amazonaws.com',
                      ) > 0
                        ? getCloudImageUrl(
                            item.product_variant_images[0].URL,
                            500,
                          )
                        : emptyImage(item.product.category.name)
                    }
                    alt=""
                  />
                  {categoryName === 'handbags' ? (
                    <p className="homepage-product__brand">
                      {brand?.flat?.length > 0 ? brand?.flat[0] : brand?.name}
                    </p>
                  ) : null}
                  <p className="homepage-product__name">{item.display_name}</p>
                  <p
                    style={{ color: '#159953' }}
                    className="homepage-product__price"
                  >
                    {item.price ? (
                      <TextRupiah
                        currency="IDR. "
                        color="#159953"
                        align="right"
                        value={item.price && item.price.toString()}
                        isOnlyKickPoint={isOnlyKickPoint}
                      />
                    ) : (
                      <span style={{ color: 'red' }}>Out of stock</span>
                    )}
                  </p>
                </div>
              </Link>
            );
          }
          if (!isRecommendedProduct && !isRaffle) {
            // Product slider if isRaffle and isRecommended product props is not available
            if (
              !item.price ||
              !item.display_name ||
              !item.product_variant_images
            )
              return <div />;

            const brand = item && item.product && item.product.brand;
            const brandSlug = brand?.flat?.[0] ? convertBrandNameToSlug(brand?.flat?.[0]) : brand?.slug;

            let pathname = `${categoryUrl}/${brandSlug}/${item.slug}`;
            let search = ``;
            if (slug && !isCollectionHero && !item.vintage)
              search += `?collection=${slug}`;
            if (!slug && isCollectionHero && !item.vintage)
              search += '?express_shipping=true';
            if (!slug && !isCollectionHero && item.vintage)
              search += '?vintage=true';

            if (slug && isCollectionHero && !item.vintage)
              search += `?collection=${slug}&express_shipping=true`;
            if (!slug && isCollectionHero && item.vintage)
              search += `?express_shipping=true&vintage=true`;
            if (slug && !isCollectionHero && item.vintage)
              search += `?collection=${slug}&vintage=true`;

            if (slug && isCollectionHero && item.vintage)
              search += `?collection=${slug}&express_shipping=true&vintage=true`;

            if (collectionId) {
              search += `&collection_id=${collectionId}`;
            }

            if(search.includes('?')){
              search += '&from=home';
            }
            else{
              search += '?from=home'
            }

            const categoryName =
              item &&
              item.product &&
              item.product.category &&
              item.product.category.name;
            const isOnlyKickPoint = item?.variant_payment_methods?.length === 1 && !!item?.variant_payment_methods?.find((item) => item?.payment_method === "kick_point" || item === "kick_point");

            return (
              <div key={item.id} className="homepage-product__section">
                {/* ini gausah pake object pathname. kalo pake, nanti query paramsnya nggak masuk ke search. agak ribet pas get value query paramsnya. butuh split dll */}
                {/* kalau mau pake pathname, pakein search juga */}
                {/* ini nanti coba diimplement di yang lainnya ya */}
                <Link to={{ pathname, search }}>
                  <div
                    style={{
                      position: item.editors_choice && 'relative',
                      boxShadow: hasShadow && '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
                    }}
                    className="homepage-product__container"
                  >
                    {item.editors_choice && (
                      <KickImage
                        className="isHotProduct"
                        src={HotProduct}
                        alt="hot product"
                      />
                    )}
                    <KickImage
                      className="homepage-product__img"
                      src={
                        item.product_variant_images.length > 0 &&
                        item.product_variant_images[0].URL.indexOf(
                          's3.amazonaws.com',
                        ) > 0
                          ? getCloudImageUrl(
                              item.product_variant_images[0].URL,
                              500,
                            )
                          : emptyImage(item.product.category.name)
                      }
                      alt=""
                    />
                    {categoryName === 'handbags' ? (
                      <p className="homepage-product__brand">
                        {brand?.flat?.length > 0 ? brand?.flat[0] : brand?.name}
                      </p>
                    ) : null}
                    <p className="homepage-product__name">
                      {item.display_name}
                    </p>
                    <p
                      style={{ color: '#159953' }}
                      className="homepage-product__price"
                    >
                      {item.price ? (
                        <TextRupiah
                          currency="IDR. "
                          color="#159953"
                          align="right"
                          value={item.price && item.price.toString()}
                          isOnlyKickPoint={isOnlyKickPoint}
                        />
                      ) : (
                        <span style={{ color: 'red' }}>Out of stock</span>
                      )}
                    </p>
                  </div>
                </Link>
              </div>
            );
          } else {
            const brand = item && item.product && item.product.brand;
            const brandSlug = brand?.flat?.[0] ? convertBrandNameToSlug(brand?.flat?.[0]) : brand?.slug;
            let pathname = isRaffle
              ? `${category}/raffle/${query}`
              : `${categoryUrl}/${brandSlug}/${item.slug}`;

            let search = ``;
            if (slug && !isCollectionHero && !item.vintage)
              search += `?collection=${slug}`;
            if (!slug && isCollectionHero && !item.vintage)
              search += '?express_shipping=true';
            if (!slug && !isCollectionHero && item.vintage)
              search += '?vintage=true';

            if (slug && isCollectionHero && !item.vintage)
              search += `?collection=${slug}&express_shipping=true`;
            if (!slug && isCollectionHero && item.vintage)
              search += `?express_shipping=true&vintage=true`;
            if (slug && !isCollectionHero && item.vintage)
              search += `?collection=${slug}&vintage=true`;

            if (slug && isCollectionHero && item.vintage)
              search += `?collection=${slug}&express_shipping=true&vintage=true`;

            if (collectionId) {
              search += `&collection_id=${collectionId}`;
            }

            if(search.includes('?')){
              search += '&from=home';
            }
            else{
              search += '?from=home'
            }

            const categoryName =
              item &&
              item.product &&
              item.product.category &&
              item.product.category.name;
            const isOnlyKickPoint = item?.variant_payment_methods?.length === 1 && !!item?.variant_payment_methods?.find((item) => item?.payment_method === "kick_point" || item === "kick_point");

            return (
              <Link
                to={{ pathname, isCollectionHero, search }}
                key={item.id}
                className="homepage-product__section"
              >
                <div
                  style={{
                    position: item.editors_choice && 'relative',
                  }}
                  className="homepage-product__container"
                >
                  {item.editors_choice && (
                    <KickImage
                      className="isHotProduct"
                      src={HotProduct}
                      alt="hot product"
                    />
                  )}
                  {isRaffle ? (
                    <KickImage
                      className="homepage-product__img"
                      src={
                        item.image
                          ? getCloudImageUrl(item.image, 500)
                          : emptyImage(item.category)
                      }
                      alt=""
                    />
                  ) : (
                    <KickImage
                      className="homepage-product__img"
                      src={
                        item.image_url &&
                        item.image_url.indexOf('s3.amazonaws.com') > 0
                          ? getCloudImageUrl(item.image_url, 500)
                          : emptyImage(item.category)
                      }
                      alt=""
                    />
                  )}
                  {categoryName === 'handbags' ? (
                    <p className="homepage-product__brand">
                      {brand?.flat?.length > 0 ? brand?.flat[0] : brand?.name}
                    </p>
                  ) : null}
                  <p className="homepage-product__name">{item.display_name}</p>
                  <p
                    style={{ color: '#159953' }}
                    className="homepage-product__price"
                  >
                    {isRaffle && item.price ? (
                      <TextRupiah
                        currency="IDR. "
                        color="#159953"
                        align="right"
                        value={item.price && item.price.toString()}
                        isOnlyKickPoint={isOnlyKickPoint}
                      />
                    ) : !isRaffle && item.latest_price ? (
                      <TextRupiah
                        currency="IDR. "
                        color="#159953"
                        align="right"
                        value={
                          item.latest_price && item.latest_price.toString()
                        }
                        isOnlyKickPoint={isOnlyKickPoint}
                      />
                    ) : (
                      <span style={{ color: 'red' }}>Out of stock</span>
                    )}
                  </p>
                </div>
              </Link>
            );
          }
        })}
      {chosenOption && dataProducts.length > 0 && (
        <Link
          target="_blank"
          to={navigateUrl}
          onClick={() => {
            localStorage.removeItem('collectionSortedBy');
          }}
          className="homepage-lastSlide"
        >
          <div
            style={{
              border: isHotProducts ? '1px solid #fff' : '1px solid #e0e0e0',
            }}
            className="homepage-showAll"
          >
            <h4 style={{ color: isHotProducts ? '#fff' : '#242424' }}>
              View All
            </h4>
            <p style={{ color: isHotProducts ? '#fff' : '#242424' }}>
              {chosenOption}
            </p>
          </div>
        </Link>
      )}
    </Slider>
  );
};

interface DataCategory {
  selected: string;
}

type mapState = {
  dataCategory: DataCategory;
};

const mapStateToProps = (state: mapState) => ({
  dataCategory: state.dataCategory.selected,
});

export default connect(mapStateToProps, null)(withRouter(ProductSlider));